import RouterSection from '@/Layout/components/RouterSection'
import { checkAuthorization } from '../NavigationGuards';

export default {
  path: '/orderSend',
  name: 'orderSend_home',
  component: RouterSection,
  mode: 'history',
  children: [
    {
      // 장바구니 발송
      path: 'cartSend',
      name: 'cartSend',
      component: () => import('@/views/orderSend/CartSend'),
      beforeEnter: checkAuthorization
    },

    {
      // 임시저장 발송
      path: 'tempSend',
      name: 'tempSend',
      component: () => import('@/views/orderSend/TempSend'),
      beforeEnter: checkAuthorization
    },
    {
      // 연동(API) 발송
      path: 'apiintro',
      name: 'apiintro',
      component: () => import('@/views/orderSend/ApiIntro')
    }
  ]
}